import styled from "styled-components";
import { device } from "../constants/breakpoints";

export const View = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background-color: ${({ theme }) => theme.grey_100};
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${device.tablet} {
    width: 100vw;
  }
  @media ${device.phone} {
    width: 100vw;
  }

  .header-view {
    width: 100%;
    display: flex;
    flex-direction: column;
    top: 60px;
    position: fixed;
    z-index: 9000;
    background-color: ${({ theme }) => theme.white};
    border-bottom: 1px solid ${({ theme }) => theme.grey_200};
    padding: 0 30px;
    padding-top: 20px;
    max-height: 200px;

    @media ${device.tablet} {
      padding: 0 40px;
      padding-top: 10px;
    }
    @media ${device.phone} {
      padding: 0 20px;
      padding-top: 10px;
    }

    .id {
      margin-bottom: 10px;
      display: flex;
      align-items: center;

      h3 {
        font-size: 1.5rem;
        font-weight: 500;
        margin-right: 20px;
      }

      span {
        padding: 4px 12px;
        border-radius: 4px;
      }

      .open {
        color: ${({ theme }) => theme.blue_600} !important;
        background-color: ${({ theme }) => theme.blue_50} !important;
      }
      .closed {
        color: ${({ theme }) => theme.green} !important;
        background-color: ${({ theme }) => theme.green_50} !important;
      }
    }

    .location-view {
      width: 100%;
      display: flex;
      align-items: center;

      @media ${device.phone} {
        flex-direction: column;
        align-items: flex-start;
      }

      .hub {
        display: flex;
        align-items: center;
        margin-right: 20px;

        span {
          margin-left: 10px;
        }
      }
    }

    .tab-view {
      width: 100%;
      display: flex;
      margin-top: 30px;

      @media ${device.phone} {
        margin-top: 10px;
      }

      button {
        padding: 6px 0;
        margin-right: 20px;
        background-color: transparent;
        border: none;
        outline: none;
        cursor: pointer;
        font-weight: 600;
        color: ${({ theme }) => theme.grey_400};
        font-size: 0.9rem;
        transition: all 0.2s ease-in-out;
        border-bottom: 2px solid ${({ theme }) => theme.white};
      }

      .active {
        color: ${({ theme }) => theme.blue_600};
        border-bottom: 2px solid ${({ theme }) => theme.blue_600};
        transition: all 0.2s ease-in-out;
      }
    }
  }

  .content {
    width: 100%;
    height: 100%;
    padding: 0 30px;
    padding-top: 220px;

    @media ${device.phone} {
      padding: 20px;
      padding-top: 220px;
    }
  }
`;
